<script setup>
import { ref, onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { getUnixStartOfDay, getUnixEndOfDay } from 'helpers/DateHelper';
import Report from 'dashboard/api/reports';

const props = defineProps({
  // When set, counts only conversations from this inbox/channel.
  inboxId: {
    type: [Number, String],
    default: null,
  },
});

const { t } = useI18n();

const count = ref(0);
const isLoading = ref(false);

const fetchTodayCount = async () => {
  isLoading.value = true;
  try {
    const now = new Date();
    const from = getUnixStartOfDay(now);
    const to = getUnixEndOfDay(now);
    const type = props.inboxId ? 'inbox' : 'account';
    const { data } = await Report.getSummary(
      from,
      to,
      type,
      props.inboxId || undefined
    );
    count.value = data?.conversations_count || 0;
  } catch {
    count.value = 0;
  } finally {
    isLoading.value = false;
  }
};

onMounted(fetchTodayCount);
watch(() => props.inboxId, fetchTodayCount);
</script>

<template>
  <div
    class="flex items-center justify-between gap-3 px-4 py-3 mb-2 shadow outline-1 outline outline-n-container rounded-xl bg-n-solid-2"
  >
    <span class="text-sm font-medium text-n-slate-11">
      {{ t('REPORT.CONVERSATIONS_TODAY') }}
    </span>
    <span class="text-xl font-semibold text-n-slate-12">
      {{ isLoading ? '…' : count.toLocaleString() }}
    </span>
  </div>
</template>
